import withBoundary from 'component/ErrorBoundary/withBoundary';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Implements a React {@link Component} for the frame of the overlays.
 */
class OverlayFrame extends React.PureComponent {
  /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {ReactElement|null}
   */
  render() {
    return (
      <div
        className={
          this.props.isLightOverlay
            ? 'overlay__container-light'
            : 'overlay__container'
        }
        id="overlay"
        onClick={this.props.onClick}
        style={this.props.style}>
        <div className={'overlay__content'}>{this.props.children}</div>
      </div>
    );
  }
}
export default withBoundary(OverlayFrame);
/**
 * The type of the React {@code Component} props of {@link OverlayFrame}.
 */
OverlayFrame.propTypes = {
  /**
   * The children components to be displayed into the overlay frame.
   */
  children: PropTypes.any,

  /**
   * Indicates the css style of the overlay. If true, then lighter; darker,
   * otherwise.
   */
  isLightOverlay: PropTypes.bool,

  /**
   * Click handler for the overlay frame.
   */
  onClick: PropTypes.func,

  /**
   * The style property.
   */
  style: PropTypes.object
};
